import RotatingQuestionItem from './RotatingQuestionItem.container';

export default RotatingQuestionItem;
